import React from "react";

const AcceptPage = (props) => {
    return (
        <div className="results-modal">
            <div className="results-modal__overlay"></div>
            <div className="results-modal-window">
                <div className="results-modal-window__agree-wrap">
                    Я согласен на обезличенную обработку данных моей компании в целях просмотра общего рейтинга
                </div>
                <div className="results-modal-window__btn-wrap">
                    <div className="btn btn-brand" onClick={() => props.setAcceptProcessData(true)}>
                        Показать результаты
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AcceptPage;
